module.exports = __webpack_public_path__ + "static/media/mong1.232c6ed2.png";